import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  {
    title: '1. Aceitação dos Termos',
    content: `Ao aceder e utilizar o website da MoveMind Consulting, Lda. (doravante "MoveMind"), concorda com os presentes Termos de Uso. Se não concordar com alguma das condições aqui estabelecidas, deverá abster-se de utilizar este website.`,
  },
  {
    title: '2. Sobre a MoveMind Consulting',
    content: `A MoveMind Consulting é uma empresa de consultoria empresarial sediada em Luanda, Angola, especializada em Due Diligence, Fusões & Aquisições, Estratégia Empresarial, Reestruturação e Captação de Investimento. O presente website tem carácter informativo e comercial.`,
  },
  {
    title: '3. Utilização do Website',
    content: `O utilizador compromete-se a utilizar este website de forma lícita e de acordo com as presentes condições. É expressamente proibido:\n\n• Utilizar o website para fins ilegais ou não autorizados.\n• Tentar aceder a áreas restritas sem autorização.\n• Transmitir vírus, malware ou qualquer código malicioso.\n• Reproduzir, copiar ou distribuir conteúdos sem autorização prévia e escrita da MoveMind.\n• Utilizar meios automatizados (bots, scrapers) para recolher informação do website.`,
  },
  {
    title: '4. Propriedade Intelectual',
    content: `Todo o conteúdo presente neste website — incluindo textos, imagens, logótipos, gráficos, vídeos e design — é propriedade exclusiva da MoveMind Consulting ou dos seus licenciantes, e está protegido pelas leis de propriedade intelectual aplicáveis em Angola e internacionalmente.\n\nNenhum conteúdo poderá ser reproduzido, distribuído ou utilizado sem autorização prévia e escrita da MoveMind.`,
  },
  {
    title: '5. Informações e Conteúdos',
    content: `As informações disponibilizadas neste website têm carácter meramente informativo e não constituem aconselhamento jurídico, financeiro ou de investimento. A MoveMind não garante a exactidão, completude ou actualidade de todas as informações publicadas.\n\nPara aconselhamento específico, recomendamos que contacte directamente a nossa equipa.`,
  },
  {
    title: '6. Limitação de Responsabilidade',
    content: `A MoveMind não se responsabiliza por:\n\n• Danos directos ou indirectos resultantes do uso ou impossibilidade de uso do website.\n• Erros, omissões ou imprecisões no conteúdo publicado.\n• Interrupções ou falhas técnicas do website.\n• Conteúdos de websites de terceiros para os quais existam hiperligações.\n\nA utilização do website é feita por conta e risco do utilizador.`,
  },
  {
    title: '7. Hiperligações para Terceiros',
    content: `Este website pode conter hiperligações para websites de terceiros. Estas ligações são fornecidas apenas para conveniência do utilizador. A MoveMind não controla esses websites e não se responsabiliza pelo seu conteúdo, políticas de privacidade ou práticas.`,
  },
  {
    title: '8. Disponibilidade do Website',
    content: `A MoveMind reserva-se o direito de suspender, modificar ou encerrar o website, total ou parcialmente, a qualquer momento e sem aviso prévio, nomeadamente para manutenção, actualização ou por razões técnicas.`,
  },
  {
    title: '9. Alterações aos Termos',
    content: `A MoveMind reserva-se o direito de alterar os presentes Termos de Uso a qualquer momento. As alterações entram em vigor imediatamente após a sua publicação no website. O uso continuado do website após a publicação de alterações constitui aceitação dos novos termos.`,
  },
  {
    title: '10. Lei Aplicável e Foro Competente',
    content: `Os presentes Termos de Uso são regidos pela lei angolana. Para a resolução de quaisquer litígios emergentes da utilização deste website, as partes elegem o foro da comarca de Luanda, com expressa renúncia a qualquer outro.`,
  },
  {
    title: '11. Contacto',
    content: `Para esclarecimentos sobre estes Termos de Uso, contacte-nos:\n\n• **Email:** geral@movemind.ao\n• **Telefone:** +244 925 434 499\n• **Morada:** Av. Pedro de Castro Van-Dúnem, Ed. 24, 1º Andar, Apt 11, Bairro Miramar Luanda – Angola`,
  },
];

export default function TermsPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F2EE]">
      <Navbar />

      {/* Hero */}
      <section className="bg-[#011820] pt-36 pb-20">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <div className="inline-flex items-center gap-2 border border-[#026A86]/40 rounded-full px-4 py-1.5 mb-6">
            <span className="text-[#026A86] text-xs font-medium tracking-widest uppercase">
              Legal
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
            Termos de <span className="text-[#026A86]">Uso</span>
          </h1>
          <p className="text-white/50 text-base">
            Última actualização: Janeiro de 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-10">

          {/* Intro card */}
          <div className="bg-white rounded-2xl p-8 mb-10 border border-[#011820]/8">
            <p className="text-[#011820]/70 text-base leading-relaxed">
              Estes Termos de Uso regulam o acesso e a utilização do website da MoveMind Consulting. Leia atentamente antes de utilizar os nossos serviços digitais. A utilização do website implica a aceitação integral destes termos.
            </p>
          </div>

          {/* Sections */}
          <div className="flex flex-col gap-6">
            {sections.map((section) => (
              <div key={section.title} className="bg-white rounded-2xl p-8 border border-[#011820]/8">
                <h2 className="text-lg font-bold text-[#011820] mb-4">{section.title}</h2>
                <div className="text-[#011820]/65 text-sm leading-relaxed">
                  {section.content.split('\n').map((line, i) => {
                    if (line.startsWith('• **') && line.includes(':**')) {
                      const parts = line.replace('• **', '').split(':**');
                      return (
                        <p key={i} className="mb-2">
                          <span className="text-[#011820]/40 mr-1">•</span>
                          <strong className="text-[#011820]/80">{parts[0]}:</strong>
                          {parts[1]}
                        </p>
                      );
                    }
                    if (line.startsWith('• ')) {
                      return (
                        <p key={i} className="mb-2">
                          <span className="text-[#026A86] mr-2">•</span>
                          {line.replace('• ', '')}
                        </p>
                      );
                    }
                    if (line === '') return <br key={i} />;
                    return <p key={i} className="mb-2">{line}</p>;
                  })}
                </div>
              </div>
            ))}
          </div>

          {/* Back link */}
          <div className="mt-12 flex items-center justify-between">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#026A86] text-sm font-medium hover:underline cursor-pointer"
            >
              <i className="ri-arrow-left-line" />
              Voltar ao início
            </Link>
            <Link
              to="/politica-de-privacidade"
              className="inline-flex items-center gap-2 border border-[#026A86] text-[#026A86] text-sm font-medium px-5 py-2 rounded-full hover:bg-[#026A86] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Ver Política de Privacidade
              <i className="ri-arrow-right-line text-xs" />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
